export default "__VITE_ASSET__DBK0INP8__"